export const COUNTRY_CODES = [
  { code: "254", label: "🇰🇪 +254 (Kenya)" },
  { code: "256", label: "🇺🇬 +256 (Uganda)" },
  { code: "255", label: "🇹🇿 +255 (Tanzania)" },
  { code: "250", label: "🇷🇼 +250 (Rwanda)" },
  { code: "251", label: "🇪🇹 +251 (Ethiopia)" },
  { code: "211", label: "🇸🇸 +211 (South Sudan)" },
  { code: "234", label: "🇳🇬 +234 (Nigeria)" },
  { code: "27", label: "🇿🇦 +27 (South Africa)" },
  { code: "44", label: "🇬🇧 +44 (UK)" },
  { code: "1", label: "🇺🇸 +1 (USA)" },
];
